export default __webpack_public_path__ + "img/0178dbcd13a368ee585f455094567b74.svg";